module.exports = __webpack_public_path__ + "assets/img/btn-view-28cc08f6.png";